<editable-list
    [itemsFormArray]="itemsFormArray"
    [addLabel]="addLabel"
    [sortable]="sortable"
    [disableRawEdit]="disableRawEdit"
    [fullHeightList]="fullHeightList"
    [useVirtualScroll]="useVirtualScroll"
    [virtualScrollItemSize]="virtualScrollItemSize"
    [virtualScrollHeight]="virtualScrollHeight"
    [confirmDeletion]="confirmDeletion"
    (onAdd)="onAdd.emit($event)"
    (onDelete)="onDelete.emit($event)"
    (onValidityChange)="onValidityChange.emit($event)">
    <ng-template let-item="item" let-goToNext="goToNext" let-index="index">
        <editable-list-template (onInputEnter)="goToNext($event)">
            <i class="info-item" *ngIf="iconFn && items[index]" [ngClass]="iconFn(items[index])"></i>
            <editable-list-input
                [inputControl]="item?.get([keyIdentifier])"
                (inputChange)="setSuggestions($event, keyIdentifier)"
                placeholder="{{keyPlaceholder}}"
                [required]="keyRequired"
                [suggestions]="filteredKeySuggestions"
                (onFocus)="handleFocus($event, keyIdentifier)"
                [warnIfTrimmable]="warnIfTrimmable">
            </editable-list-input>
            <editable-list-arrow></editable-list-arrow>
            <editable-list-input
                [inputControl]="item?.get(valueIdentifier)"
                (inputChange)="setSuggestions($event, valueIdentifier)"
                placeholder="{{valuePlaceholder}}"
                [required]="valueRequired"
                [suggestions]="filteredValueSuggestions"
                (onFocus)="handleFocus($event, valueIdentifier)"
                [warnIfTrimmable]="warnIfTrimmable">
            </editable-list-input>
        </editable-list-template>
    </ng-template>
</editable-list>
